export const LOGIC_TEST_VALIDATION_ERRORS = {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    INVALID_TOKEN: 'INVALID_TOKEN',
    VALIDATION_TEST_RESULT_NOT_FOUND: 'VALIDATION_TEST_RESULT_NOT_FOUND'
};
